import { baseApi } from "@/redux/api/baseApi";
import { TReshippingDetailsResponse } from "./productShippingType";

const productShippingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getReshippingData: builder.query<TReshippingDetailsResponse, string>({
      query: (actor_id) => ({
        url: `/product-shipping/get-reshipping-data/${actor_id}`,
        method: "GET",
      }),
    }),

    uploadReshippingDetails: builder.mutation({
      query: ({ id, shipping_invoice, expected_delivery_date }) => ({
        url: `/product-shipping/upload-reshipping-details/${id}`,
        method: "POST",
        body: {
          shipping_invoice,
          expected_delivery_date,
        },
      }),
    }),
 
  }),
});

export const { useGetReshippingDataQuery, useUploadReshippingDetailsMutation, } =
  productShippingApi;
